import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IChatsPanelButtonProps } from './types';
import { CHATS_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`ChatsPanelButton`) : null;

export function ChatsPanelButton ({
    boardId,
    tooltip,
    isShow,
    indicatorBoolean,
    onClick
}: IChatsPanelButtonProps) {
    if (!isShow) {
        return null;
    }
    if (analyzeRender) analyzeRender.call(`ChatsPAnelButton ${boardId}`);
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.CHATS}
            indicatorBoolean={indicatorBoolean}
            title={CHATS_BUTTON}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.CHATS)
                onClick();
            }}
        />
    );
}
